if (!customElements.get('gb-product-video')) {
  customElements.define('gb-product-video', class extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      this.lifecycle = new AbortController();
      this.button = this.querySelector('[data-video-play]');
      this.frame = this.querySelector('[data-video-frame]');
      this.status = this.querySelector('[data-video-status]');
      this.videoId = this.parseVideoId(this.dataset.videoUrl);
      if (!this.button || !this.frame || !this.videoId) return;
      this.button.hidden = Boolean(this.frame.querySelector('iframe'));
      this.button.addEventListener('click', () => this.play(), { signal: this.lifecycle.signal });
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = null;
    }

    parseVideoId(value) {
      try {
        const url = new URL(value);
        if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return null;
        const host = url.hostname.toLowerCase();
        const path = url.pathname.split('/').filter(Boolean);
        let id;
        if (host === 'youtu.be' || host === 'www.youtu.be') {
          id = path.length === 1 ? path[0] : null;
        } else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
          if (path.length === 1 && path[0] === 'watch') id = url.searchParams.get('v');
          else if (path.length === 2 && ['embed', 'shorts', 'live'].includes(path[0])) id = path[1];
        }
        return /^[A-Za-z0-9_-]{11}$/.test(id || '') ? id : null;
      } catch {
        return null;
      }
    }

    play() {
      if (!this.videoId || this.frame.querySelector('iframe')) return;
      const url = new URL(`https://www.youtube-nocookie.com/embed/${this.videoId}`);
      url.searchParams.set('autoplay', '1');
      url.searchParams.set('playsinline', '1');
      url.searchParams.set('hl', document.documentElement.lang || 'en');
      const iframe = document.createElement('iframe');
      iframe.title = this.dataset.videoTitle || this.button.getAttribute('aria-label');
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.src = url.href;
      iframe.addEventListener('load', () => {
        if (this.status) this.status.textContent = '';
      }, { once: true, signal: this.lifecycle.signal });
      iframe.addEventListener('error', () => {
        if (this.status) this.status.textContent = this.dataset.errorMessage || '';
      }, { once: true, signal: this.lifecycle.signal });
      this.button.hidden = true;
      if (this.status) this.status.textContent = this.dataset.loadingMessage || '';
      this.frame.append(iframe);
      iframe.focus({ preventScroll: true });
    }
  });
}
